import i18n from './i18n'

import pushEventAddToCartEshop from '#/local/service/dataLayer/pushEventAddToCartEshop'
import searchReportEshop from '#/local/service/searchReport/eshop'

import { redrawSnippets } from '#/local/service'

import { Config } from '#/global/helper/Config'
import { Location } from '#/global/helper/Location'
import { MessageFlash } from '#/global/helper/MessageFlash'

import type { AddToCartEshopAfter } from '#/global/types'

const addToCartEshopAfter = (event: CustomEvent<AddToCartEshopAfter>) => {
    const detail = event.detail
    const { eventInvoker, isSuccess, product, quantitySales } = detail
    const t = i18n[Config.getLang()]
    const showMessage = eventInvoker === 'slide' && Location.isCart()

    if (isSuccess) {
        redrawSnippets()
        pushEventAddToCartEshop(product, quantitySales)
        searchReportEshop(product.code)

        showMessage && MessageFlash.addSuccess(t.addToCart.success)
    } else {
        showMessage && MessageFlash.addError(t.addToCart.error)
    }
}
export default addToCartEshopAfter
